export const heartOptions = {
  history: ['Pouco suspeita', 'Moderadamente suspeita', 'Altamente suspeita'],
  ecg: ['Normal', 'Alterações inespecíficas de repolarização', 'Desvio significativo do segmento ST'],
  age: ['Abaixo de 45 anos', '45 a 64 anos', '65 anos ou mais']
};

export const riskFactors = [
  'Hipertensão',
  'Hipercolesterolemia',
  'Diabetes',
  'Obesidade (IMC acima de 30)',
  'Tabagismo atual ou cessado há até 3 meses',
  'História familiar de doença coronariana precoce'
];

export const timiCriteria = [
  'Idade de 65 anos ou mais',
  'Três ou mais fatores de risco para doença coronariana',
  'Estenose coronariana conhecida de 50% ou mais',
  'Uso de aspirina nos últimos 7 dias',
  'Angina grave: dois ou mais episódios em 24 horas',
  'Desvio do ST de 0,5 mm ou mais',
  'Marcador cardíaco positivo'
];

export function riskLevel(score, type) {
  if (score === null) return null;
  if (type === 'HEART') return score <= 3 ? 'Baixo' : score <= 6 ? 'Intermediário' : 'Alto';
  return score <= 2 ? 'Baixo' : score <= 4 ? 'Intermediário' : 'Alto';
}
